__turbopack_context__.v({
  "authentication-button": "authentication-button-module-scss-module__qyGU8q__authentication-button",
  "authentication-button-login": "authentication-button-module-scss-module__qyGU8q__authentication-button-login",
  "authentication-button__icon": "authentication-button-module-scss-module__qyGU8q__authentication-button__icon",
  "mobile-authentication-button": "authentication-button-module-scss-module__qyGU8q__mobile-authentication-button",
});
